import { SourceTypes } from '../../../../constants';
import {
  getDataServiceExcludeContentFilters,
  getDataServicePage,
  getDataServicePostsFetcher,
  getDataServicePostsSelector,
  getPostsURL,
  getSourceStatusURL
} from '../../utils';
import type { ProviderType } from '../types';
import type { TwitterResponseType, TwitterSourceValue } from './types';
import { twitterExcludeFiltersKeys } from './utils';

const PLATFORM = SourceTypes.TWITTER;

export function createTwitterHashtagProvider(
  sourceValue: TwitterSourceValue,
  globalKey: string[],
  filtersKey: string[],
  widgetToken: string
): ProviderType<TwitterResponseType> {
  const {
    source = '',
    sourcePID = '',
    status,
    _customWidgetDataPostsLimit
  } = sourceValue;
  const excludeFilters = getDataServiceExcludeContentFilters(
    sourceValue,
    twitterExcludeFiltersKeys
  );
  const excludeFiltersKey = JSON.stringify(excludeFilters);
  const key = [...globalKey, ...filtersKey, source, excludeFiltersKey, status];

  const statusURL = getSourceStatusURL(sourcePID);

  const postsURL = getPostsURL({
    sourcePID,
    filters: excludeFilters,
    limit: _customWidgetDataPostsLimit
  });

  const page = getDataServicePage(postsURL);

  const select = getDataServicePostsSelector({
    platform: PLATFORM,
    domain: 'x.com',
    shouldUseVideoProxy: true,
    widgetToken
  });

  const customFetch = getDataServicePostsFetcher({
    status,
    statusURL,
    postsURL,
    widgetToken,
    platform: PLATFORM
  });

  return { key, select, fetch: customFetch, page };
}
